/* tslint:disable */
/* eslint-disable */
/**
 * Atlas API
 * Atlas API
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    Attachment,
    AttachmentFromJSON,
    AttachmentFromJSONTyped,
    AttachmentToJSON,
    ResponseBase,
    ResponseBaseFromJSON,
    ResponseBaseFromJSONTyped,
    ResponseBaseToJSON,
} from './';

/**
 * 
 * @export
 * @interface AttachmentResponse
 */
export interface AttachmentResponse {
    /**
     * Message related to response
     * @type {string}
     * @memberof AttachmentResponse
     */
    msg: string;
    /**
     * 
     * @type {Attachment}
     * @memberof AttachmentResponse
     */
    entry: Attachment;
}

export function AttachmentResponseFromJSON(json: any): AttachmentResponse {
    return AttachmentResponseFromJSONTyped(json, false);
}

export function AttachmentResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): AttachmentResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'msg': json['msg'],
        'entry': AttachmentFromJSON(json['entry']),
    };
}

export function AttachmentResponseToJSON(value?: AttachmentResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'msg': value.msg,
        'entry': AttachmentToJSON(value.entry),
    };
}


